/* eslint-disable import/prefer-default-export */
import { CASE_EXPOSURES } from '@app/constants/feature-definitions';
import {
  type CaseVisibilityScope,
  resolveExposureWall,
} from '@app/helpers/case-visibility';
import { useAppSelector } from '@app/hooks/redux';
import { useAllowedCaseTypes } from '@app/selectors/case-type';
import { useExposures } from '@app/services/exposures';
import { useEffectiveFeatures } from '@app/services/organization-features';

/** The user's case visibility scope, for filtering live updates the same way the API filters Mongo reads. */
export const useCaseVisibilityScope = (): CaseVisibilityScope => {
  const allowedCaseTypes = useAllowedCaseTypes();
  const { data: featureMap } = useEffectiveFeatures();
  const { data: exposureTypes } = useExposures({
    enabled: Boolean(featureMap?.[CASE_EXPOSURES]),
  });
  const exposureSkills = useAppSelector(
    (state) => state?.auth?.user?.exposureSkills,
  );

  return {
    allowedCaseTypes,
    exposureWall: resolveExposureWall(
      featureMap,
      exposureTypes,
      exposureSkills,
    ),
  };
};
